export const siteConfig = {
  // Business Information
  business: {
    name: 'Humble Hand Studio',
    tagline: 'Beautiful Hand-Crafted Calligraphy on Tables, Slates, Trays & Jewelry',
    description: 'Transform your words into elegant works of art on beautiful surfaces. From custom calligraphy on tables and slates to personalized trays and jewelry, our hand-crafted designs bring beauty and sophistication to your special moments.',
    founded: '2020',
    logo: 'HH', // Single letter logo
  },

  // Contact Information
  contact: {
    email: 'hello@calligraphyart.com',
    phone: '+1 (555) 123-4567',
    address: {
      street: '123 Art Street',
      city: 'Creative City',
      state: 'CC',
      zip: '12345',
      country: 'United States',
      full: '123 Art Street, Creative City, CC 12345, United States'
    },
    businessHours: {
      monday: '9:00 AM - 6:00 PM',
      tuesday: '9:00 AM - 6:00 PM',
      wednesday: '9:00 AM - 6:00 PM',
      thursday: '9:00 AM - 6:00 PM',
      friday: '9:00 AM - 6:00 PM',
      saturday: '10:00 AM - 4:00 PM',
      sunday: 'Closed'
    },
    responseTime: '24 hours'
  },

  // Social Media Links
  social: {
    instagram: {
      url: 'https://instagram.com/calligraphyart',
      handle: '@calligraphyart',
      platform: 'Instagram'
    },
    facebook: {
      url: 'https://facebook.com/calligraphyart',
      handle: '@calligraphyart',
      platform: 'Facebook'
    },
    twitter: {
      url: 'https://twitter.com/calligraphyart',
      handle: '@calligraphyart',
      platform: 'Twitter'
    },
    pinterest: {
      url: 'https://pinterest.com/calligraphyart',
      handle: '@calligraphyart',
      platform: 'Pinterest'
    }
  },

  // Email Configuration
  email: {
    // EmailJS Configuration (replace with your actual values)
    serviceId: 'YOUR_EMAILJS_SERVICE_ID',
    templateId: 'YOUR_EMAILJS_TEMPLATE_ID',
    publicKey: 'YOUR_EMAILJS_PUBLIC_KEY',
    
    // Email addresses for different purposes
    contact: 'hello@calligraphyart.com',
    orders: 'orders@calligraphyart.com',
    support: 'support@calligraphyart.com',
    
    // Email templates
    templates: {
      contact: 'contact_form',
      order: 'order_confirmation',
      newsletter: 'newsletter_signup'
    }
  },

  // SEO Configuration
  seo: {
    title: 'Humble Hand Studio - Beautiful Hand-Crafted Calligraphy on Tables, Slates, Trays & Jewelry',
    description: 'Transform your words into elegant works of art on beautiful surfaces. Custom calligraphy on tables, slates, trays, and jewelry. Hand-crafted designs for your special moments.',
    keywords: 'calligraphy, tables, slates, trays, jewelry, hand lettering, custom art, elegant writing, personalized gifts',
    author: 'Humble Hand Studio',
    ogImage: 'https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=1200&h=630&fit=crop',
    twitterHandle: '@humblehandstudio',
    canonicalUrl: 'https://humblehandstudio.com'
  },

  // Business Policies
  policies: {
    shipping: {
      freeThreshold: 50, // Free shipping over $50
      standardDelivery: '5-7 business days',
      expressDelivery: '2-3 business days',
      international: true
    },
    returns: {
      policy: '30-day return policy',
      conditions: 'Items must be unused and in original packaging',
      contact: 'support@calligraphyart.com'
    },
    privacy: {
      policyUrl: '/privacy',
      termsUrl: '/terms',
      cookiePolicy: '/cookies'
    }
  },

  // Features and Services
  services: {
    categories: ['Tables', 'Slates', 'Trays', 'Jewelry'],
    customizations: [
      'Text content',
      'Font style', 
      'Color scheme',
      'Surface material',
      'Size options',
      'Design placement'
    ],
    turnaround: {
      standard: '1-2 weeks',
      rush: '3-5 business days',
      custom: 'Varies by complexity'
    }
  },

  // Testimonials (can be moved to a separate data file if needed)
  testimonials: [
    {
      id: '1',
      name: 'Sarah Johnson',
      role: 'Homeowner',
      content: 'The custom calligraphy on our dining table is absolutely stunning! It adds such an elegant touch to our home. Everyone who visits comments on how beautiful it is.',
      rating: 5,
      image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'
    },
    {
      id: '2',
      name: 'Michael Chen',
      role: 'Restaurant Owner',
      content: 'The slate boards with calligraphy for our menu have made a huge impression on our customers. They\'re unique and professional - exactly what we were looking for.',
      rating: 5,
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
    },
    {
      id: '3',
      name: 'Emily Rodriguez',
      role: 'Interior Designer',
      content: 'The custom calligraphy tray I ordered is the perfect centerpiece for my client\'s living room. The calligraphy is so beautiful and the quality is outstanding.',
      rating: 5,
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face'
    }
  ],

  // Site URLs
  urls: {
    home: '/',
    gallery: '/gallery',
    contact: '/contact',
    cart: '/cart',
    checkout: '/checkout',
    orderSuccess: '/order-success',
    privacy: '/privacy',
    terms: '/terms'
  }
};

// Helper functions for common configurations
export const getContactInfo = () => siteConfig.contact;
export const getSocialLinks = () => siteConfig.social;
export const getBusinessInfo = () => siteConfig.business;
export const getEmailConfig = () => siteConfig.email;
export const getSEOConfig = () => siteConfig.seo;
export const getPolicies = () => siteConfig.policies; 